export interface ChartWeeksPurchaseInvoices {
  invoiceDate: Date;
  numberOfInvoices: number;
  quantity: number;
  value: number;
}
